import React from 'react'
import { TtTrayActionCard } from '@23/react'
import { useDeleteActionCardMutation } from '../../../../../ActionCards/blocs/useActionCards'
import {
  setActiveCard,
  useTrayCard,
  useTrayCardState,
} from '../../../../../firebase/hooks/useTray'
import { type TrayCardAction } from '../../../../../firebase/model/tray-cards/types/action-card-model'
import { type PropsWithTrayItemChildren } from '../../TrayItem'
import { setTrayCardEditing, useTrayCardEditingId } from '../../useTrayEditing'
import { ActionCardEditForm } from './Edit/ActionCardEditForm'
import { ActionCardOverview } from './Overview/ActionCardOverview'

interface ActionCardProps {
  id: string
}

const ActionCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<ActionCardProps>) => {
  const card = useTrayCard(id) as TrayCardAction | undefined
  const cardState = useTrayCardState(id)
  const { mutate: deleteActionCard } = useDeleteActionCardMutation()
  const cardBeingEdited = useTrayCardEditingId()

  const isCurrentlyEditing = cardBeingEdited === id

  const clearEditing = () => setTrayCardEditing(null)

  const onCardClickHandler = () => {
    setActiveCard(id)
  }

  return (
    <TtTrayActionCard
      subject="ActionCard"
      selected={cardState === 'active'}
      disabled={cardState === 'done'}
      onTt-click={(event) => {
        if (event.target === event.currentTarget) {
          onCardClickHandler()
        }
      }}
    >
      {children?.({
        canEdit: !isCurrentlyEditing,
        onDelete: deleteActionCard,
      })}

      {card && (
        <>
          {isCurrentlyEditing ? (
            <ActionCardEditForm
              card={card}
              onSubmit={clearEditing}
              onCancel={clearEditing}
            />
          ) : (
            <ActionCardOverview card={card} />
          )}
        </>
      )}
    </TtTrayActionCard>
  )
}

export default ActionCard
